import React, { Component } from 'react';
import HeaderTags from '../../common/headerTags/HeaderTags';
import AffiliatesComponent from '../../components/affiliates/containers/affiliatesContainer';
import { getAffiliatesDataIfNeeded } from '../../components/affiliates/actions/affiliatesAction';

const headerTags =
{
    title: 'Afiliadas - Conheça os benefícios e torne-se um', // | Antena 1 is automatically added by the Headers Tag
    meta:
        {
            description: 'Com 21 filiais espalhadas por todo o Brasil e Itália, a Rádio Antena 1 é líder de audiência em mais de 550 municípios. Torne-se um afiliado!',
            keywords: 'antena 1 são paulo, antena 1 campinas, antena 1 sorocaba, antena 1 ilhabela, antena 1 são josé dos campos, antena 1 jaú, antena 1 são josé do rio preto, antena 1 piracicaba, antena 1 bebedouro, antena 1 belo horizonte, antena 1 brasília, antena 1 florianópolis, antena 1 chapecó, antena 1 porto união, antena 1 porto alegre, antena 1 santa maria, antena 1 bagé, antena 1 rio grande, antena 1 vitória, antena 1 roma, antena 1 itália, antenna uno, público qualificado, ibope tagwave, ibope easymedia, comerciais',
            'og:title': 'Afiliadas - Conheça os benefícios e torne-se um',
            'og:description': 'Com 22 filiais espalhadas por todo o Brasil e Itália, a Rádio Antena 1 é líder de audiência em mais de 550 municípios. Torne-se um afiliado!',
        },
};

class Afiliadas extends Component {
    static fetchData(store) {
        return store.dispatch(getAffiliatesDataIfNeeded());
    }

    render() {
        return (
            <div className="pageWrapper tw-container tw-mx-auto tw-px-5">
                <HeaderTags title={headerTags.title} meta={headerTags.meta} />
                <AffiliatesComponent />
            </div>
        );
    }
}

export default Afiliadas;
